import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const ContactIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.4 3.933a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0ZM3.667 4.333a.4.4 0 1 0 0-.8.4.4 0 0 0 0 .8ZM6.733 3.933a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M1 6.867V1h8v5.867H7.4V9L5.267 6.867H1Zm5.867-.534h1.6v-4.8H1.533v4.8h3.955l1.379 1.379V6.333Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const ContactIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.4 3.933a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0ZM3.667 4.333a.4.4 0 1 0 0-.8.4.4 0 0 0 0 .8ZM6.733 3.933a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M1 6.867V1h8v5.867H7.4V9L5.267 6.867H1Zm5.867-.534h1.6v-4.8H1.533v4.8h3.955l1.379 1.379V6.333Z" />
        </SvgIcon>
    );
};
